import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getCategories } from '@/lib/api';
import { SEO } from '@/lib/seo';
import { Reveal } from '@/lib/motion';

export default function Shop() {
  const { category } = useParams();
  const { data: categories } = useQuery({ queryKey: ['categories'], queryFn: getCategories, staleTime: 120000 });

  const activeCat = categories?.find((c) => c.slug === category);
  const title = activeCat ? activeCat.name.replace(/^Buy | Online$/g, '') : 'Shop the Full Menu';

  return (
    <>
      <SEO
        title={`${title} | Majestic Greens DMV — Washington, DC Cannabis`}
        description={`Shop ${title.toLowerCase()} at Majestic Greens DMV, Washington DC. Live menu, secure checkout, ID verification. Adults 21+.`}
        path={category ? `/shop/${category}` : '/shop'}
      />
      <div data-testid="shop-page" className="mx-auto max-w-7xl px-6 pt-28">
        <Reveal>
          <p className="text-[11px] font-bold uppercase tracking-[0.4em] text-bronze">
            <Link to="/shop" className="hover:text-bronzehover">Shop</Link>
            {activeCat && <span className="text-ash"> / {activeCat.name.replace(/^Buy | Online$/g, '')}</span>}
          </p>
          {!activeCat && (
            <>
              <h1 className="mt-4 font-serif text-4xl text-ink sm:text-6xl">{title}</h1>
            </>
          )}
        </Reveal>
      </div>
    </>
  );
}
